import { jsx as _jsx } from "react/jsx-runtime";
import { concat, map } from 'lodash';
import { Stack, Checkbox } from '@fluentui/react';
import { useColumnSelect } from '../Provider/useColumnSelect';
/**
 * Lister for the checkboxes to show/hide individual columns.
 */
export const ColumnCheckBoxList = () => {
    const { allColumnList, selectedKeyList, setSelectedKeyList } = useColumnSelect();
    const onChange = key => (e, checked) => {
        if (checked) {
            const change = concat(selectedKeyList, key);
            setSelectedKeyList(change);
        }
        else {
            const change = selectedKeyList === null || selectedKeyList === void 0 ? void 0 : selectedKeyList.filter(w => w !== key);
            setSelectedKeyList(change || []);
        }
    };
    return (_jsx(Stack, Object.assign({ tokens: { childrenGap: '1.5em' } }, { children: map(allColumnList, col => (_jsx(Checkbox, { label: col.name, onChange: onChange(col.key), checked: selectedKeyList ? selectedKeyList.indexOf(col.key) > -1 : false }, `${col.key}-checkbox`))) })));
};
